.tile {
  height: 100%;
  border-width: var(--ant-line-width-bold);
  cursor: pointer;
}

.tileSelected {
  border-color: var(--ant-color-primary);
  box-shadow: 0 0 0 var(--ant-line-width-bold) var(--ant-color-primary-border);
}

.tileDisabled {
  cursor: not-allowed;
  opacity: 0.6;
}

.cover {
  aspect-ratio: 4 / 3;
  overflow: hidden;
  background: var(--ant-color-fill-quaternary);
}

.cover :global(.ant-image) {
  width: 100%;
  height: 100%;
}

.cover :global(.ant-image-img) {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.checkbox {
  pointer-events: none;
}

.caption {
  flex: 1;
  min-width: 0;
}
